import { enableAutoTrack, makeTracker } from './auto';
import { type EventArgs, type Events } from './events';
import { mixpanel } from './mixpanel';
import { sentry } from './sentry';
export const track = makeTracker((event, props) => {
  mixpanel.track(event, props);
});

export {
  CRASH_DIAGNOSTICS_NOTICE_VERSION,
  DEFAULT_TELEMETRY_CONSENT,
  isPurposeAllowed,
  normalizeTelemetryConsent,
  type OptionalPurposeState,
  type TelemetryConsent,
  type TelemetryRuntime,
} from './consent';
export { enableAutoTrack, type EventArgs, type Events, mixpanel, sentry };
export default track;
